import React, { useState } from 'react';
import propTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import { useSelector } from 'react-redux';
import ClassificationForm from '../forms/ClassificationForm';
import { EDIT_TYPES } from '../../constants';

const ClassificationModal = ({ visible, onClose, submitForm, error, title }) => {
  const [submit, setSubmit] = useState(false);
  const { detail, translations, edit, choosen_translation } = useSelector(
    (state) => (state as any).classification
  );

  const formSubmit = (values) => {
    submitForm(values);
    setSubmit(false);
  };

  const getChoosenTranslationData = () => {
    return translations.find((trans) => trans?.language?.code === choosen_translation);
  };

  const setDataToForm = () => {
    if (edit) {
      if (edit === EDIT_TYPES.detail) {
        return detail;
      }
      return getChoosenTranslationData();
    }
    return null;
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <ClassificationForm
            submitOutside={submit}
            submit={formSubmit}
            formProps={setDataToForm()}
            type={edit}
            error={error}
            data={[]}
          />
        </DialogBody>
        <DialogFooter>
          <Button
            key={1}
            variant="outline"
            onClick={() => onClose()}
            data-testid="classification-modal-close-btn"
          >
            Zavřít
          </Button>
          <Button
            key={2}
            onClick={() => setSubmit(true)}
            data-testid="classification-modal-save-btn"
          >
            Uložit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

ClassificationModal.propTypes = {
  visible: propTypes.bool,
  onClose: propTypes.func,
  submitForm: propTypes.func,
  formProps: propTypes.any,
  error: propTypes.any,
  title: propTypes.string,
};

export default ClassificationModal;
